import { useEffect } from 'react'
import StageMail from 'components/auth/register/StageMail'
import StageRegister from 'components/auth/register/StageRegister'
import StageCode from 'components/auth/register/StageCode'
import StageTypeSelection from 'components/auth/register/StageTypeSelection'
import StageBranch from 'components/auth/register/StageBranch'
import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { stages } from 'utils/Constants'
import StagePassword from 'components/auth/register/StagePassword'
import StageAddresses from 'components/auth/register/StageAdresses'
import StageTakeaway from 'components/auth/register/StageTakeaway'
import StageForgotStep1 from 'components/auth/register/StageForgotStep1'
import ChoiceBranch from 'components/auth/register/ChoiceBranch'
import StageAddAddresses from 'components/auth/register/StageAddAddresses'
import StageForgotPassword from 'components/auth/register/StageForgotPassword'
import StageForgotNextPassword from 'components/auth/register/StageForgotNextPassword'
import StageResetPassword from 'components/auth/register/StageResetPassword'
import auth from 'utils/Auth'
import StageWithoutRegister from 'components/auth/register/StageWithouthRegister'
import {useDispatch} from 'react-redux'
import {setCurrentStage} from 'redux/features/general/generalSlice'

const Register = () => {
	const dispatch = useDispatch()
	const token = auth.isHaveToken()
	const location = useLocation()
	const isWithouthregister = location.pathname == '/misafir-girisi'
	const [registerStage, setRegisterState] = useState(
		token ? stages.STAGE_TYPE_SELECTION : isWithouthregister ? stages.STAGE_REGISTER : stages.STAGE_MAIL
	)
	const isLogin = location.pathname == '/uye-girisi'
	//const navigate = useNavigate();
	//const parameters = auth.getUserChoises();

	//   useEffect(() => {
	//       if(token && parameters?.deliveryType && parameters?.neighbourhoodId && parameters?.restaurantId){
	//          navigate('/')
	//       }
	//   },[location])

	useEffect(() => {
		window.scrollTo(0, 0)
		dispatch(setCurrentStage(registerStage))
	}, [registerStage])

	const StageComponent = () => {
		switch (registerStage) {
			case stages.STAGE_MAIL:
				return <StageMail setRegisterState={setRegisterState} />
			case stages.STAGE_REGISTER:
				if (isLogin) {
					return <StagePassword setRegisterState={setRegisterState} />
				} else if (isWithouthregister) {
					return <StageWithoutRegister setRegisterState={setRegisterState} />
				} else {
					return <StageRegister setRegisterState={setRegisterState} />
				}
			case stages.STAGE_FORGOT_PASSWORD:
				return <StageForgotPassword setRegisterState={setRegisterState} />
			case stages.STAGE_FORGOT_NEXT_PASSWORD:
				return <StageForgotNextPassword setRegisterState={setRegisterState} />
			case stages.STAGE_RESET_PASSWORD:
				return <StageResetPassword setRegisterState={setRegisterState} />
			case stages.STAGE_CODE:
				return <StageCode setRegisterState={setRegisterState} />
			case stages.STAGE_TYPE_SELECTION:
				return <StageTypeSelection isLogin={isLogin} setRegisterState={setRegisterState} />
			//case stages.STAGE_MY_ADDRESS:
			//   return <StageMyAddress setRegisterState={setRegisterState} />
			case stages.STAGE_CHOICE_BRANCH:
				return <ChoiceBranch setRegisterState={setRegisterState} />
			case stages.STAGE_ADDRESSES:
				return <StageAddresses setRegisterState={setRegisterState} />
			case stages.STAGE_ADD_ADDRESS:
				return <StageAddAddresses forHome setRegisterState={setRegisterState} />
			case stages.STAGE_BRANCH:
				return <StageBranch forHome setRegisterState={setRegisterState} />
			case stages.STAGE_NEWLOGIN:
				return <StagePassword setRegisterState={setRegisterState} />
			case stages.STAGE_TAKEAWAY:
				return <StageTakeaway setRegisterState={setRegisterState} />
			case stages.STAGE_FORGOTSTEP1:
				return <StageForgotStep1 setRegisterState={setRegisterState} />
			default:
				return <StageMail setRegisterState={setRegisterState} />
		}
	}
	return (
		<div className={`register ${registerStage == stages.STAGE_TAKEAWAY ? 'pt-0' : ''}`}>
			<StageComponent />
		</div>
	)
}

export default Register
